<template>
  <div class="component-input-investments">
    <FormWizardStepHeader
      title="Add investments"
      :optional="isOptional"
      description="Add the companies that you invested in"
    />

    <AlertSlideUpDown :show="$v.investments && $v.investments.$error"
      >Please add at least one investment</AlertSlideUpDown
    >

    <div class="list">
      <div v-if="form.investments.length" class="mb-60">
        <SlickList
          v-if="form.investments.length > 1"
          :key="`slicklist-${form.investments.length}`"
          v-model="form.investments"
        >
          <SlickItem
            v-for="(item, index) in form.investments"
            :key="index"
            :index="index"
            class="item"
          >
            <ListItem :item="item" @remove="remove" @edit="edit" />
          </SlickItem>
        </SlickList>

        <div v-if="form.investments.length === 1" key="single" class="item">
          <ListItem :item="form.investments[0]" @remove="remove" @edit="edit" />
        </div>
      </div>
    </div>

    <AddInvestment v-if="canAddInvestment" @add="add" @addNew="addNew" />

    <CreateInvestorsAddInvestmentModal
      v-model="isNewModalOpen"
      :editing="editing"
      :name="addName"
      @submit="onAddSubmit"
    />
  </div>
</template>

<script>
import { SlickItem, SlickList } from 'vue-slicksort';
import AlertSlideUpDown from '@/components/AlertSlideUpDown';
import AddInvestment from './Investments/AddInvestment';
import ListItem from './Investments/ListItem';
import FormWizardStepHeader from '@/components/FormWizardStepHeader';
import CreateInvestorsAddInvestmentModal from '@/modals/create-investors/CreateInvestorsAddInvestment';

import InvestorInvestmentModel from '@/models/InvestorInvestment';

import { investorRequireInvestments } from '@/constants';

export default {
  name: 'InvestorFormStepInvestments',
  components: {
    FormWizardStepHeader,
    AlertSlideUpDown,
    ListItem,
    AddInvestment,
    SlickItem,
    SlickList,
    CreateInvestorsAddInvestmentModal
  },
  props: {
    $v: {
      type: Object,
      required: true
    },
    value: {
      type: Object
    },
    forms: {
      type: Object
    }
  },
  data() {
    return {
      isNewModalOpen: false,
      form: {
        investments: this.value.investments.map((item) => new InvestorInvestmentModel(item))
      },
      editing: null,
      addName: ''
    };
  },
  computed: {
    isOptional() {
      return investorRequireInvestments.indexOf(this.forms.basics.category) === -1;
    },
    canAddInvestment() {
      return this.form.investments.length < 20;
    }
  },
  watch: {
    isNewModalOpen(value) {
      if (!value) {
        this.editing = null;
      }
    },
    value(newValue) {
      this.form.investments = newValue.investments.map((item) => new InvestorInvestmentModel(item));
    },
    form: {
      deep: true,
      handler() {
        this.$emit('input', this.form);
      }
    }
  },
  methods: {
    addNew(name) {
      this.isNewModalOpen = true;

      this.addName = name;
    },
    onAddSubmit(data) {
      if (this.editing) {
        this.editing.update(data);
      } else {
        this.add(data);
      }
    },
    add(investment) {
      const found = this.form.investments.find((item) => {
        return item.company && investment.company && item.company.id === investment.company.id;
      });

      if (found) {
        return;
      }

      // console.log('a', new InvestorInvestmentModel(investment))

      this.form.investments.push(new InvestorInvestmentModel(investment));
    },
    remove(investment) {
      const index = this.form.investments.indexOf(investment);
      this.form.investments.splice(index, 1);
    },
    edit(investment) {
      this.editing = investment;

      this.isNewModalOpen = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.component-input-investments {
  .list {
    .item {
      background: #fff;
      border-bottom: 1px solid $border-color;
    }
  }
}
</style>
